import { useState } from 'react'
import './contact.scss'

export default function Contact() {
const [message,setMessage]=useState(false)

    const handleSubmit=(e)=>{
        e.preventDefault()
        setMessage(true)
    }
    return (
        <div className="contact" id="contact">
            <div className="left">
                <img src="assets/shake.gif" alt=""/>
            </div>
            <div className="right">
                <h3>..Contact..</h3>
                <form onSubmit={handleSubmit}>
                    <input type="text" placeholder="Email" required />
                    <textarea placeholder="Message" required></textarea>
                    <button type="submit">Send</button>
                    {message && <span>Thanks, I'll reply ASAP :)</span>}
                </form>
            </div>
        </div>
    )
}
